import { render, staticRenderFns } from "./ellipsisTemplate.vue?vue&type=template&id=23769958&scoped=true&"
import script from "./ellipsisTemplate.vue?vue&type=script&lang=js&"
export * from "./ellipsisTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ellipsisTemplate.vue?vue&type=style&index=0&id=23769958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23769958",
  null
  
)

export default component.exports